module.exports = __webpack_public_path__ + "static/media/save-time.13fe3d70.gif";